<div class="toast-notifications-wrapper bottom center">
  <div class="toast-notification" ngClass="{{ item.type }} {{ item.className }}" *ngFor="let item of notifications">
    <div class="content">
      <app-ds-icon class="icon" size="icon-size-2" [color]="types[item.type].color" [name]="types[item.type].icon"></app-ds-icon>
      <div class="message ds-ui-2" [innerHtml]="item.message"></div>
      <div class="close">
        <app-ds-icon (click)="item.closeFn()" size="icon-size-2" name="x" color="var(--color-core-neutral-2)"></app-ds-icon>
      </div>
    </div>
    @if (!item.permanent) {
      <app-toast-notifications-progress [duration]="item.duration"></app-toast-notifications-progress>
    }
  </div>
</div>
